import { FC } from "react";
import styles from "../Defect.module.scss";
interface DefectCardItemProps {
  label: string;
  value: any;
}

const DefectCardItem: FC<DefectCardItemProps> = ({ label, value = "" }) => {
  return (
    <div className={styles.defect__cardItem}>
      <div className={styles.defect__cardLabel}>{label}</div>
      <div className={styles.defect__cardValue}>{value}</div>
    </div>
  );
};

export default DefectCardItem;
